import React from 'react'
import Slider from 'react-slick'

const logos = [
  "/assets/images/home-logo-1.webp",
  "/assets/images/home-logo-2.webp",
  "/assets/images/home-logo-3.webp",
  "/assets/images/home-logo-4.webp",
  "/assets/images/home-logo-5.webp",
  "/assets/images/home-logo-6.webp",
  "/assets/images/home-logo-7.webp",
  "/assets/images/home-logo-8.webp",
  "/assets/images/home-logo-9.webp",
  "/assets/images/home-logo-10.webp",
  "/assets/images/home-logo-11.webp",
]

var settings1 = {
  dots: false,
  slidesToShow: 6,
  infinite: true,
  autoplay: true,
  slidesToScroll: 1,
  pauseOnHover: false,
  arrows: false,
  cssEase: "linear",
  autoplaySpeed: 0,
  speed: 5000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 599,
      settings: {
        slidesToShow: 2,
      },
    },],
};

export default function HomeClientLogo() {
  return (
    <>
      <section className="home-client-logo">
        <span>Trusted by 2,400+ document-Driven Businesses Worldwide</span>
        <Slider {...settings1}>
          {logos?.map((logo, index) => (
            <div key={index} className="client-logo-slide">
              <img src={logo} alt="Client Logo" loading='lazy' />
            </div>
          ))}
        </Slider>
      </section>
    </>
  )
}
